import React from 'react';
import PropTypes from 'prop-types';

import TableReport from '@componentes/TableReport';
import Table from './Table';
import IntlMessage from "../../../../../../helpers/intlMessage";

const ImpressaoLaudosCriticos = ({ lista }) => (
  <TableReport
    title={<IntlMessage id = "dashboards.reports.criticalReports"/>}
    assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
  >
    {lista.map((item, i) => (
      <tr key={i} style={{ border: 0 }}>
        <td style={{ border: 0, padding: 0 }}>
          <Table item={item} />
        </td>
      </tr>
    ))}
  </TableReport>
);

ImpressaoLaudosCriticos.propTypes = {
  lista: PropTypes.array.isRequired
};

ImpressaoLaudosCriticos.defaultProps = {
  lista: []
};

export default ImpressaoLaudosCriticos;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoCritico/Relatorios/LaudosCriticos/Impressao/index.js